import { cloneDeep } from "lodash";

import HitCard from "./HitCard";
import { useEffect, useMemo, useState } from "react";
import { ROWS_PER_PAGE_ON_PAGINATED_TABLE } from "lookup";
import { cn } from "utils";

const PageButton = ({ symbol, goToPage, disabled }) => {
  return (
    <button
      className={cn("border px-2 bg-gray-50 rounded", {
        "!bg-gray-200 opacity-50": disabled,
      })}
      onClick={goToPage}
      disabled={disabled}
    >
      {symbol}
    </button>
  );
};

const PaginationButtons = ({ goToPage, currentPage, totalPages }) => {
  return (
    <div className="flex justify-end my-4 items-center w-full">
      <span className="flex w-[100px] items-center justify-center text-sm font-medium">
        Page {currentPage} of {totalPages}
      </span>
      <div className="flex gap-x-2">
        <PageButton
          symbol={"<<"}
          goToPage={() => goToPage(1)}
          disabled={currentPage === 1}
        />
        <PageButton
          symbol={"<"}
          goToPage={() => goToPage(currentPage - 1)}
          disabled={currentPage === 1}
        />

        <PageButton
          symbol={">"}
          goToPage={() => {
            goToPage(currentPage + 1);
          }}
          disabled={currentPage === totalPages}
        />

        <PageButton
          symbol={">>"}
          goToPage={() => goToPage(totalPages)}
          disabled={currentPage === totalPages}
        />
      </div>
    </div>
  );
};

const MatchAgentListView = ({
  items,
  collectionKey,
  activeTabName,
  localPagination,
  onVisibleItemsChange,
}) => {
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = ROWS_PER_PAGE_ON_PAGINATED_TABLE;

  const totalPages = localPagination
    ? Math.ceil(items.length / itemsPerPage)
    : 0;
  const startIndex = localPagination ? (currentPage - 1) * itemsPerPage : 0;

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const visibleItems = useMemo(() => {
    if (!localPagination) {
      return items;
    }

    return items.slice(startIndex, startIndex + itemsPerPage);
  }, [items, itemsPerPage, localPagination, startIndex]);

  useEffect(() => {
    onVisibleItemsChange(visibleItems);
  }, [onVisibleItemsChange, visibleItems]);

  const hits = cloneDeep(items);

  for (const hit of hits) {
    if (hit.rankDetails?.ideal) {
      hit.rankDetails = {
        ...hit.rankDetails,
        isFirstIdeal: true,
      };

      break;
    }
  }

  const currentItems = localPagination
    ? hits.slice(startIndex, startIndex + itemsPerPage)
    : hits;

  return (
    <>
      <div className="relative flex flex-col gap-8">
        {currentItems.map((hit) => (
          <HitCard
            key={hit.id}
            hit={hit}
            collectionKey={collectionKey}
            activeTabName={activeTabName}
          />
        ))}
      </div>
      {localPagination && (
        <PaginationButtons
          goToPage={goToPage}
          currentPage={currentPage}
          totalPages={totalPages}
        />
      )}
    </>
  );
};

export default MatchAgentListView;
